export default {
    back: 'Back',
    signout: 'Sign out',
    home: {
        title: 'Admin\'s Panel',
        configFile: 'Configuration File',
        mcList: {
            title: 'Current Masters of Ceremonies',
            edit: 'Edit',
            editPwd: 'Change password',
            delete: 'Delete',
            newBtn: 'Add new Master of Ceremonies',
            deleteModal: {
                title: 'Delete Master of Ceremonies',
                text: '¿Are you sure you want to delete {{username}} as a Master or Ceremonies?',
                doneBtn: 'Yes, delete it!',
                cancelBtn: 'No!'
            }
        },
        mcModal: {
            title: {
                new: 'New Master of Ceremonies',
                edit: 'Edit {{username}}',
                editPwd: 'Edit {{username}}\'s password'
            },
            username: 'Username',
            password: 'Password',
            saveBtn: 'Save',
            cancelBtn: 'Cancel'
        }
    },
    config: {
        title: 'Admin\'s Config File',
        intro: 'Here you can change internal configuration. Please, note these are critical paramenters that affect every game in progress and future.',
        currentFile: 'Current Config File',
        defaultFile: 'Default Config File (read-only)',
        updateBtn: 'UPDATE',
        restoreBtn: 'RESTORE',
        updateConfirmation: {
            title: 'Update Config File',
            text: 'Are you sure you want to update the Config File? It will affect every game in progress and future.',
            doneBtn: 'UPDATE',
            cancelBtn: 'CANCEL'
        },
        restoreConfirmation: {
            title: 'Restore Default Config File',
            text: 'Are you sure you want to restore the default Config File? It will restore the original default configuration. The effect won\'t be taken until you click the Update button.',
            doneBtn: 'RESTORE',
            cancelBtn: 'CANCEL'
        },
        validationError: {
            title: 'Validation Error',
            text: 'Please, be sure all the fields are valid (you should see warning icons next to every invalid fields).'
        }
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/superadmin.js